import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const reasons = [
  { num: '01', title: '12 Years of Expertise', desc: 'Founded in 2012, Spark Zone has powered over 15,000 homes, offices, and factories across Gujarat. Our experienced team knows every electrical challenge inside-out.' },
  { num: '02', title: 'ISI & BIS Certified Products Only', desc: 'We refuse to stock substandard goods. Every item on our shelves carries the required ISI, BIS, or CE mark — protecting you and your property.' },
  { num: '03', title: 'Certified Electrician Team', desc: 'Our installation engineers are ITI-certified with 5+ years of field experience. We carry full liability insurance on all service work.' },
  { num: '04', title: 'Same-Day & Next-Day Delivery', desc: 'Order before 3PM and receive your items the same day within Ahmedabad. We also offer pan-Gujarat delivery within 48 hours.' },
  { num: '05', title: 'Best Price Guarantee', desc: "Found it cheaper anywhere in Ahmedabad? Show us the price and we'll match it — or beat it. No questions, no hassle." },
  { num: '06', title: 'After-Sales Support & AMC', desc: "We don't disappear after the sale. Our service team is available 7 days a week, and we offer Annual Maintenance Contracts for long-term peace of mind." },
];

const testimonials = [
  { text: 'Spark Zone rewired our entire 4-BHK in just 3 days. Extremely professional team, zero mess, and the pricing was very competitive.', name: 'Ravi Mehta', role: 'Homeowner, Satellite', stars: 5 },
  { text: "We've been sourcing all our factory's electrical requirements from Spark Zone for 6 years. Never once had a quality issue or a delay.", name: 'Dhruv Shah', role: 'Factory Manager, GIDC Vatva', stars: 5 },
  { text: 'Their solar team installed our 10kW rooftop system. The process was smooth, the pricing was transparent, and the DISCOM approval was handled by them.', name: 'Priya Desai', role: 'Business Owner, Navrangpura', stars: 5 },
];

const certifications = [
  { icon: '🏅', label: 'ISI Certified Dealer' },
  { icon: '⚡', label: 'CEIG Approved' },
  { icon: '🌞', label: 'MNRE Empanelled' },
  { icon: '🛡️', label: 'ISO 9001:2015' },
];

function WhyUs() {
  return (
    <div className="page-wrapper">

      {/* Page Hero */}
      <section className="page-hero bg-grid">
        <div className="container">
          <div className="tag animate-fadeInUp">The Spark Difference</div>
          <h1 className="page-hero-title" style={{ marginTop: '12px' }}>
            WHY CHOOSE <span style={{ color: 'var(--primary)' }}>US</span>
          </h1>
          <p className="page-hero-desc">
            Over a decade of trust, expertise, and quality — here's why thousands of customers keep coming back to Spark Zone.
          </p>
          <div className="page-hero-line"></div>
        </div>
      </section>

      {/* Why Layout */}
      <section className="section">
        <div className="container">
          <div className="whyus-layout">
            {/* Visual */}
            <div className="whyus-visual animate-fadeInLeft">
              <div className="whyus-image-wrap">
                <div className="whyus-image-bg">⚡</div>
              </div>
              <div className="whyus-badge">
                <div className="whyus-badge-num">15K+</div>
                <div className="whyus-badge-text">HAPPY CLIENTS</div>
              </div>
            </div>

            {/* Reasons */}
            <div>
              <div className="section-subtitle">⚡ Our Strengths</div>
              <h2 className="section-title" style={{ marginBottom: '40px' }}>
                THE SPARK <span>ADVANTAGE</span>
              </h2>
              <div className="whyus-items">
                {reasons.map((r, i) => (
                  <div className="whyus-item" key={i} style={{ animationDelay: `${i * 0.1}s` }}>
                    <div className="whyus-item-num">{r.num}</div>
                    <div>
                      <div className="whyus-item-title">{r.title}</div>
                      <p className="whyus-item-desc">{r.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Counters */}
      <section className="counters-section">
        <div className="container">
          <div className="counters-grid">
            {[
              { num: '15,000+', label: 'Happy Customers' },
              { num: '2,500+', label: 'Products In Stock' },
              { num: '12 Yrs', label: 'In Business' },
              { num: '98%', label: 'Satisfaction Rate' },
            ].map((c, i) => (
              <div className="counter-item" key={i}>
                <span className="counter-num">{c.num}</span>
                <div className="counter-label">{c.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="section">
        <div className="container">
          <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '70px' }}>
            {certifications.map((c, i) => (
              <div
                key={i}
                style={{
                  display: 'flex', alignItems: 'center', gap: '12px',
                  padding: '16px 28px',
                  background: 'var(--card-bg)', border: '1px solid var(--card-border)',
                  borderRadius: '12px',
                  fontFamily: "'Rajdhani', sans-serif", fontWeight: 700, fontSize: '1rem',
                  letterSpacing: '0.5px',
                  opacity: 0, animation: `fadeInUp 0.5s ease ${i * 0.1}s forwards`,
                }}
              >
                <span style={{ fontSize: '1.5rem' }}>{c.icon}</span>
                {c.label}
              </div>
            ))}
          </div>

          {/* Testimonials */}
          <div className="section-header" style={{ textAlign: 'center' }}>
            <div className="section-subtitle">⚡ Customer Stories</div>
            <h2 className="section-title">WHAT THEY <span>SAY</span></h2>
          </div>

          <div className="testimonials-grid">
            {testimonials.map((t, i) => (
              <div className="testimonial-card" key={i} style={{ animationDelay: `${i * 0.12}s` }}>
                <div className="testimonial-stars">{'★'.repeat(t.stars)}</div>
                <p className="testimonial-text">"{t.text}"</p>
                <div className="testimonial-author">
                  <div className="testimonial-avatar">👤</div>
                  <div>
                    <div className="testimonial-name">{t.name}</div>
                    <div className="testimonial-role">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">
            EXPERIENCE THE <span style={{ color: 'var(--primary)' }}>SPARK DIFFERENCE</span>
          </h2>
          <p className="cta-desc">
            Join 15,000+ satisfied customers who trust Spark Zone for all their electrical needs.
          </p>
          <div className="cta-actions">
            <Link to="/contact" className="btn-primary">⚡ Get In Touch</Link>
            <Link to="/products" className="btn-outline">Browse Products</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default WhyUs;
